import React, { useEffect, useRef, useState } from "react";
import { configureWorkShiftsColumns } from "./ConfigureWorkShifts.config";
import {
  ListActionButton,
  Notification,
} from "../../../../../../components/common";
import { Button, Col, notification, Row, Space, Table, Typography } from "antd";
import Icons from "../../../../../../assets/icons";
import ModalCustom from "../../../../../../components/common/ModalCustom/ModalCustom";
import ModalAction from "./ModalAction/ModalAction";
import { employeeService } from "api";
import { items } from "layout/main-layout/header/config";
import { data } from "data/env";
import { setLoading } from "redux/reducer/medicineStore";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import {
  saveTableOptions,
  getTableOptions,
} from "helper/common";
import { useAppSelector } from "redux/hooks";
import usePermission from "hooks/usePermission";

const ConfigureWorkShifts = () => {
  let savedTableOption = getTableOptions(
    "CONFIGURE_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? configureWorkShiftsColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : configureWorkShiftsColumns;
  const [columns, setColumns] = useState(
    defaultColumns.filter((item) => item.show)
  );
  columns.find((e) => e.dataIndex === "index").render = (
    text,
    record,
    index
  ) => {
    const rowNumber = (currentPage - 1) * params.limit + index + 1;
    return rowNumber;
  };
  const { isNhanVien, isQuanLy, isGiamDoc } = usePermission();
  const modalRef = useRef<any>();
  const [dataSource, setDataSource] = useState([]);
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [params, setParams] = useState<any>({
    limit: limit,
    page: currentPage,
  });

  useEffect(() => {
    getList();
  }, []);

  columns.find((e) => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteContract2(_record.id);
          //   ;
        }}
        editFunction={() => {
          setType("Sửa");
          setRecord(_record);
          modalRef.current?.openModal();
        }}
        disabled={{
          deleteFunction: isNhanVien() || isQuanLy() || isGiamDoc(),
          editFunction: isNhanVien() || isQuanLy() || isGiamDoc(),
        }}
      ></ListActionButton>
    );
  };
  //Delete
  const deleteContract2 = async (id) => {
    try {
      const res = await employeeService.deleteShiftWorkSetting(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");
      getList();
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu");
    }
  };

  useEffect(() => {
    getList();
  }, [params]);
  useEffect(() => {
    setParams({ ...params, limit: limit, page: currentPage });
  }, [currentPage, limit]);
  const onPageChange = (pg: number, pageSize?: number) => {
    setCurrentPage(pg);
    setLimit(pageSize);
  };
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "CONFIGURE_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const handleOnAdd = () => {
    setType("Thêm");
    setRecord(null);
    modalRef.current?.openModal();
  };
  const getList = async (page = 1, limit = 1000) => {
    setLoading(true);
    try {
      const paramss = { page, limit };
      const response = await employeeService.getShiftWorkSetting(paramss);
      setDataSource(response);
      setLoading(false);
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi load danh sách chi tiết thông tin"
      );
      setLoading(false);
    }
  };
  return (
    <div className="container">
      <Space direction="vertical" style={{ width: "100%" }} size={"small"}>
        <Row justify={"end"}>
          <Col>
            <Space>
              <Button
                type="primary"
                // icon={<Icons.add rev={0} />}
                onClick={handleOnAdd}
                disabled={isNhanVien() || isQuanLy() || isGiamDoc()}
              >
                Thêm mới
              </Button>
            </Space>
          </Col>
        </Row>
        <CustomResizableTable
          bordered
          setShowColumns={setShowColumnsList}
          dataSource={dataSource}
          columns={columns}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            onChange: onPageChange,
            total: total,
            pageSize: limit,
            current: currentPage,
          }}
          scroll={{ x: 1500 }}
        />
      </Space>
      <ModalCustom ref={modalRef} width={1200} title={`${type} ca làm việc`}>
        <ModalAction
          data={record}
          getListStore={getList}
          type={type}
        ></ModalAction>
      </ModalCustom>
    </div>
  );
};
export default ConfigureWorkShifts;
